import { StateNode, TLEventHandlers, TLPointerEvent } from '@tldraw/tldraw'

export class PointingContent extends StateNode {
  static override id = 'pointing_content'

  override onCancel: TLEventHandlers['onCancel'] = () => {
    this.editor.setCurrentTool('select.mask.idle', {})
  }

  override onPointerMove: TLPointerEvent = (info) => {
    if (this.editor.inputs.isDragging) {
      this.editor.setCurrentTool('select.mask.translating_content', info)
    }
  }

  override onPointerUp: TLPointerEvent = (info) => {
    this.editor.setCurrentTool('select.mask.idle', info)
  }
}
